import { render, staticRenderFns } from "./CopyStakeWheelOfFortuneCampaignsTableFiltersDialog.vue?vue&type=template&id=08f67ace&scoped=true&lang=pug"
import script from "./CopyStakeWheelOfFortuneCampaignsTableFiltersDialog.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWheelOfFortuneCampaignsTableFiltersDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWheelOfFortuneCampaignsTableFiltersDialog.vue?vue&type=style&index=0&id=08f67ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f67ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCheckbox,VCol,VForm,VRow,VSelect,VSpacer,VTextField})
